/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import {
  CONVERSATION_PERMISSIONS,
  LEGACY_AGENT_ONLY_PERMISSIONS,
  QA_LIVE_MONITOR_VIEW_PERMISSIONS,
} from '../../../constants/permissions';
import ConversationView from './ConversationView.vue';
import ArchivesView from '../archives/ArchivesView.vue';

const CONVERSATION_ROUTE_PERMISSIONS = {
  anyOf: [
    'administrator',
    LEGACY_AGENT_ONLY_PERMISSIONS,
    CONVERSATION_PERMISSIONS,
  ],
};

const QA_LIVE_MONITOR_PERMISSIONS = {
  anyOf: [
    'administrator',
    LEGACY_AGENT_ONLY_PERMISSIONS,
    QA_LIVE_MONITOR_VIEW_PERMISSIONS,
  ],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/dashboard'),
      name: 'home',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: () => {
        return { inboxId: 0 };
      },
    },
    {
      path: frontendURL('accounts/:accountId/qa-monitor'),
      name: 'qa_monitor_home',
      meta: {
        permissions: QA_LIVE_MONITOR_PERMISSIONS,
      },
      component: ConversationView,
      props: () => {
        return { inboxId: 0, isQAMonitor: true };
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/qa-monitor/conversations/:conversation_id'
      ),
      name: 'qa_monitor_conversation',
      meta: {
        permissions: QA_LIVE_MONITOR_PERMISSIONS,
      },
      component: ConversationView,
      props: route => {
        return {
          inboxId: 0,
          conversationId: route.params.conversation_id,
          isQAMonitor: true,
        };
      },
    },
    {
      path: frontendURL('accounts/:accountId/qa-monitor/inbox/:inbox_id'),
      name: 'qa_monitor_inbox',
      meta: {
        permissions: QA_LIVE_MONITOR_PERMISSIONS,
      },
      component: ConversationView,
      props: route => {
        return { inboxId: route.params.inbox_id, isQAMonitor: true };
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/qa-monitor/inbox/:inbox_id/conversations/:conversation_id'
      ),
      name: 'qa_monitor_conversation_through_inbox',
      meta: {
        permissions: QA_LIVE_MONITOR_PERMISSIONS,
      },
      component: ConversationView,
      props: route => {
        return {
          conversationId: route.params.conversation_id,
          inboxId: route.params.inbox_id,
          isQAMonitor: true,
        };
      },
    },
    {
      path: frontendURL('accounts/:accountId/archives/:conversationId?'),
      name: 'archives_view',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
        hideSecondarySidebar: true,
        useInboxPageLayout: true,
      },
      component: ArchivesView,
    },
    {
      path: frontendURL('accounts/:accountId/conversations/:conversation_id'),
      name: 'inbox_conversation',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => {
        return { inboxId: 0, conversationId: route.params.conversation_id };
      },
    },
    {
      path: frontendURL('accounts/:accountId/inbox/:inbox_id'),
      name: 'inbox_dashboard',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => {
        return { inboxId: route.params.inbox_id };
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/inbox/:inbox_id/conversations/:conversation_id'
      ),
      name: 'conversation_through_inbox',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => {
        return {
          conversationId: route.params.conversation_id,
          inboxId: route.params.inbox_id,
        };
      },
    },
    {
      path: frontendURL('accounts/:accountId/label/:label'),
      name: 'label_conversations',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({ label: route.params.label }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/label/:label/conversations/:conversation_id'
      ),
      name: 'conversations_through_label',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversation_id,
        label: route.params.label,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/team/:teamId'),
      name: 'team_conversations',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({ teamId: route.params.teamId }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/team/:teamId/conversations/:conversationId'
      ),
      name: 'conversations_through_team',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        teamId: route.params.teamId,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/issue/:issueId'),
      name: 'issue_conversations',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({ issueId: route.params.issueId }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/issue/:issueId/conversations/:conversationId'
      ),
      name: 'conversations_through_issue',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        issueId: route.params.issueId,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/custom_view/:id'),
      name: 'folder_conversations',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({ foldersId: route.params.id }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/custom_view/:id/conversations/:conversation_id'
      ),
      name: 'conversations_through_folders',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversation_id,
        foldersId: route.params.id,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/mentions/conversations'),
      name: 'conversation_mentions',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: () => ({ conversationType: 'mention' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/mentions/conversations/:conversationId'
      ),
      name: 'conversation_through_mentions',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'mention',
      }),
    },
    {
      path: frontendURL('accounts/:accountId/unattended/conversations'),
      name: 'conversation_unattended',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: () => ({ conversationType: 'unattended' }),
    },
    {
      path: frontendURL('accounts/:accountId/vip/conversations'),
      name: 'conversation_vip',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: () => ({ conversationType: 'vip' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/unattended/conversations/:conversationId'
      ),
      name: 'conversation_through_unattended',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'unattended',
      }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/vip/conversations/:conversationId'
      ),
      name: 'conversation_through_vip',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'vip',
      }),
    },
    // ---------------- Wlab AI Agent (AiLab-only) ----------------
    {
      path: frontendURL('accounts/:accountId/wlab-ai-agent/conversations'),
      name: 'conversation_wlab_ai_agent_all',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: () => ({ conversationType: 'wlab_ai_agent_all' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/wlab-ai-agent/conversations/:conversationId'
      ),
      name: 'conversation_through_wlab_ai_agent_all',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'wlab_ai_agent_all',
      }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/wlab-ai-agent/resolved/conversations'
      ),
      name: 'conversation_wlab_ai_agent_resolved',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: () => ({ conversationType: 'wlab_ai_agent_resolved' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/wlab-ai-agent/resolved/conversations/:conversationId'
      ),
      name: 'conversation_through_wlab_ai_agent_resolved',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'wlab_ai_agent_resolved',
      }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/wlab-ai-agent/handoff/conversations'
      ),
      name: 'conversation_wlab_ai_agent_handoff',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: () => ({ conversationType: 'wlab_ai_agent_handoff' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/wlab-ai-agent/handoff/conversations/:conversationId'
      ),
      name: 'conversation_through_wlab_ai_agent_handoff',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'wlab_ai_agent_handoff',
      }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/wlab-ai-agent/pending/conversations'
      ),
      name: 'conversation_wlab_ai_agent_pending',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: () => ({ conversationType: 'wlab_ai_agent_pending' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/wlab-ai-agent/pending/conversations/:conversationId'
      ),
      name: 'conversation_through_wlab_ai_agent_pending',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'wlab_ai_agent_pending',
      }),
    },
    {
      path: frontendURL('accounts/:accountId/participating/conversations'),
      name: 'conversation_participating',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: () => ({ conversationType: 'participating' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/participating/conversations/:conversationId'
      ),
      name: 'conversation_through_participating',
      meta: {
        permissions: CONVERSATION_ROUTE_PERMISSIONS,
      },
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'participating',
      }),
    },
  ],
};
